import { mdiCheckboxBlankCircleOutline } from "@mdi/js";

const themeConfig = {
  app: {
    name: "Aslı",
    iconTextLogo: require("@/assets/images/svg/icon-text-logo.png"),
    logo: require("@/assets/images/svg/logo.png"),
    logoDark: require("@/assets/images/svg/logo.png"),
    textLogo: require("@/assets/images/svg/textLogo.png"),
    textLogoDark: require("@/assets/images/svg/textLogo.png"),
    newLogo:require("@/assets/images/svg/logo-full.png"),
    isDark: true,
    isRtl: false,
    contentLayoutNav: "vertical", // vertical, horizontal
    routeTransition: "fade-transition", // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: "default", // default, bordered, semi-dark
    contentWidth: "full",
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: "fixed", // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: "hidden", // fixed, static, hidden
  },
  themes: {
    light: {
      primary: "#8d8794",
      grey: "#fafafa",
      night: "#8d8794",
      nightDark: "#efeef0",
      nightDarkTon: "#2d2844",
      secondary: "#0083e8",
      "secondary-light": "#0075cf",
      tertiary: "#f9b917",
      base: "#01c1f4",
      accent: "#0d6efd",
      success: "#56CA00",
      info: "#16B1FF",
      warning: "#FFB400",
      error: "#FF4C51",
      counter: "#efeef0",
      chip: "#8d8794",
      birincil: "#f9b917",
      ikincil: "#821517",
    },
    dark: {
      primary: "#aaa6bf",
      grey: "#3b355a",
      night: "#312d4b",
      nightDark: "#28243d",
      nightDarkTon: "#2d2844",
      secondary: "#0083e8",
      "secondary-light": "#0075cf",
      tertiary: "#ec1d23",
      base: "#01c1f4",
      accent: "#0d6efd",
      success: "#56CA00",
      info: "#16B1FF",
      warning: "#FFB400",
      error: "#FF4C51",
      counter: "#efeef0",
      chip: "#28243d",
      birincil: "#f9b917",
      ikincil: "#f9b917",
      turkuaz: "#15aaaa",
      pink: "#fda7f9",
    },
  },
};

export default themeConfig;
